<template>
    <div class="card card-body index p-0">
        <div class="top-button-group">
            <a href="/oj/courses" class="btn btn-light">Kurzy</a></div>

        <div class="d-flex">
          <div>
            <input type="text" class="form-control" placeholder="Hledat kurz" v-model="search" @input="debouncedLoadCourses">
          </div>

          <div>
            <select v-model="status" class="form-control" @change="loadCourses">
              <option value="all">Všechny</option>
              <option value="STATUS_NEW"> nové</option>
              <option value="STATUS_APPROVED"> potvrzené</option>
              <option value="STATUS_DELETED"> smazané</option>
            </select>

          </div>


            <div class="ml-auto p-2">
                <button class="btn btn-primary" @click.prevent="newCourse"><span class="material-icons mia">add_circle</span> Přidat kurz</button>
            </div>
        </div>


      <ul class="nav">
        <li class="nav-item" v-for="t in targets">
          <a :class="`nav-link ${ t == target  ? 'active': ''}`" href="#" @click.prevent="filterByTarget(t)" :key="t">{{ t }}</a>
        </li>
      </ul>
        <table class="table">
            <thead>
            <tr>
                <th @click="changeSortOrder('id')" class="cursor-pointer">ID
                  <svg v-if="sort_col=='id' && sort_order=='desc'" viewBox="0 0 24 24" width="20" height="20"><path d="M7 10l5 5 5-5H7z"></path></svg>
                  <svg v-if="sort_col=='id' && sort_order=='asc'" viewBox="0 0 24 24" width="20" height="20"><path d="M7 14l5-5 5 5H7z"></path></svg>
                </th>
                <th @click="changeSortOrder('name')" class="cursor-pointer">
                  Název
                  <svg v-if="sort_col=='name' && sort_order=='desc'" viewBox="0 0 24 24" width="20" height="20"><path d="M7 10l5 5 5-5H7z"></path></svg>
                  <svg v-if="sort_col=='name' && sort_order=='asc'" viewBox="0 0 24 24" width="20" height="20"><path d="M7 14l5-5 5 5H7z"></path></svg>
                </th>
                <th>Trh/Zdrojový jazyk</th>
                <th>Cílový jazyk</th>
                <th>Stav</th>
                <th></th> <th></th>
            </tr>
            </thead>
            <tr v-for="l in courses">
              <td>
                {{l.id}}
              </td>
                <td>
                  <a :href="`/oj/courses/${l.id}`">{{l.name}}</a>
                </td>
                <td>{{l.target}}</td>
                <td>{{l.type}}</td>

                <td>{{l.status}}</td>
                <td>
                  <a :href="`/oj/courses/${l.id}`"><span class="material-icons-outlined">mode_edit_outline</span></a>
                </td>
              <td>
                  <a class="colored"  href="#"
                     @click.prevent="removecourse(l.id)"
                     title="Smazat kurz"><span class="material-icons-outlined">clear_outlined</span></a></td>


            </tr>

        </table>

    </div>

</template>

<script>
import axios from "axios";
import {debounce} from 'lodash'

export default {
  name: "courses",
  components: {},
  data(){
    return {
        search: '',
        courses: [],
        course:{},
      status:'STATUS_APPROVED',
      targets:[],
      target:'',
      sort_col:'id',
      sort_order:'asc',
    }
  },
  created() {
    this.debouncedLoadCourses = debounce(this.loadCourses, 300);

  },

  mounted() {
    this.loadCollections()
    this.loadCourses()
  },
  methods:{
    changeSortOrder(col_name){
      if (this.sort_col == col_name) {
        this.sort_order = this.sort_order == 'asc' ? 'desc' : 'asc'
      }

      this.sort_col = col_name
      this.loadCourses()
    },

    removecourse(id){

      if (confirm('Opravdu chcete odstranit tento kurz?')) {
          axios.delete(`/oj/courses/${id}.json`)
              .then(response => {
                  this.loadCourses()
              })
              .catch(error => {
                  console.log(error)
              })
      }
    },


    filterByTarget(t){
      console.log(';filterByTarget',t)
      this.target = t
      this.loadCourses()

    },
    loadCollections(){
        axios.get('/oj/courses/collections.json',{ params:{}})
            .then(response => {
                this.targets = response.data.targets
            })
            .catch(error => {
                console.log(error)
            })
    },


      onCourseUpdated(){
          this.loadCourses()
      },
      async loadCourses(){
        const r2 = await axios.get('/oj/courses.json',{
          params:{
            target: this.target,
            search: this.search,
            status: this.status,
            sort_col: this.sort_col,
            sort_order: this.sort_order,
          }
        })
        this.courses = r2.data.items
        //for(let i in this.courses){
        //    if (this.courses[i].status==null) this.courses[i].kk_status=''
        //}

      },
      editCourse(l){
          this.course = l
          //this.$refs.modalCourse.showModal()
      },
      newCourse(){
          this.course = {}
          //this.$refs.modalCourse.showModal()
      }

  }
}
</script>

<style scoped>

.user-ico{
    width:30px;
    border-radius: 14px;
}

a.active{
  color: black;
  border-top: 1px solid black;
}


.colored
{
    color: #dc3545;
}
</style>